import * as React from "react";
import styled, { css } from "styled-components";
import AbsoluteDatePicker from "views/components/searchbar/time-range-filter/time-range-picker/AbsoluteDatePicker";
import AbsoluteTimeInput from "views/components/searchbar/time-range-filter/time-range-picker/AbsoluteTimeInput";
const ErrorMessage = styled.span(
  ({ theme }) => css`
    color: ${theme.colors.variant.dark.danger};
    font-size: ${theme.fonts.size.small};
    font-style: italic;
    padding: 3px 3px 9px;
    height: 1.5em;
  `
);
const Overlay = styled.div`
  opacity: 0.1;
`;
const Disabled = ({ disabled, children = void 0 }) => disabled ? /* @__PURE__ */ React.createElement(Overlay, null, /* @__PURE__ */ React.createElement("div", { inert: "" }, children)) : children;
const DateTimePicker = ({
  disabled = false,
  error,
  onChange,
  startDate = void 0,
  value,
  range = "Range"
}) => /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(Disabled, { disabled }, /* @__PURE__ */ React.createElement(AbsoluteDatePicker, { onChange, startDate, dateTime: value }), /* @__PURE__ */ React.createElement(AbsoluteTimeInput, { onChange, range, dateTime: value })), /* @__PURE__ */ React.createElement(ErrorMessage, null, error));
export default DateTimePicker;
